import { RFValue } from "react-native-responsive-fontsize";

export default {
  COLORS: {
    ALERT: "#ec1414",
    ICON: '#2e2e2e', //COR DOS CADEADOS E DAS SETAS PARA O LADO
    ICON_HEADER_PURCHASE: "#2e2e2e", //COR DAS SETINHAS 
    BACKGROUND_HEADER: "none", //COR DE TODOS OS CABEÇALHOS
    //TELA CLICKCOURSE, PLANS e SIGNUP
    ICON_HEADER: "#2e2e2e",  //COR DA PALAVRA ESCOLHER COMPRA, CADASTRAR-SE E COMPLETAR PAGAMENTO e VOLTAR da EDITPROFILE

    //CORES GERAIS
    PRIMARY_900: "#5C1B01", //COR MAIS ESCURA DO CLIENTE = COR PRINCIPAL DOS DETALHES DO APP - CHECKBOX, FECHAR TERMOS DE USO, ETC 
    PRIMARY_800: "#A6783F", //COR INTERMEDIÁRIA DO CLIENTE PARA INPUT LOGIN E ACTIVITY INDICATOR
    PRIMARY_700: "#F2DFA7", //COR MAIS CLARA DO CLIENTE = COR PRINCIPAL MAIS CLARA PARA INPUT LOGIN E ACTIVITY INDICATOR
    TEXT_BUTTON: "#FFFFFF", //USADA PARA O TEXTO DOS BOTÕES LOGIN, CLICKCOURSE, SIGNUP - COR DE FUNDO É A PRIMARY_900

    //CORES DO DRAWER
    DRAWER_SELECTED: "#BF9850", //COR DRAWER CLICADO E DO TEXTO DO DRAWER

    //TELAS: LOGIN, CLICKCOURSE, SIGNUP E PLANS
    BACKGROUND_ABOUT: "#F9F9F9", //COR PARA A ABOUT, DRAWER, CLICK COURSE, PLANS, EDITPROFILE, LOGIN E CADASTRO
    TITLE_ABOUT: '#734F2F', //TAMANHOS EXTRABIG, BIG E STANDARD (usadas em páginas como dos termos de uso)
    TEXT_ABOUT: '#734F2F', //TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //TELA TERMOS DE USO
    BACKGROUND_TERMS: "#FFFFFF", //COR PARA O FUNDO DOS TERMOS
    
    //TELA MAIN
    ICON_HEADER_CLICKCLASS: "#FFFFFF", //COR DO ÍCONE VOLTAR DA CLICKCLASS
    ICON_HEADER_MAIN: "#FFFFFF", //COR DO ICONE DRAWER
    BACKGROUND_MAIN: "#402F20", //COR PARA A MAIN E CLICKCLASS
    TITLE_OVERPHOTO_MAIN: "#FFFFFF", //USADA PARA O TÍTULO E SUBTÍTULO DA MAIN
    TITLE_MAIN: "#FFFFFF", //USADA PARA PARA OS TAMANHOS EXTRABIG, BIG E STANDARD
    TEXT_MAIN: "#FFFFFF", //USADA PARA PARA OS TAMANHOS MEDIUM, SMALL E EXTRASMALL

    //FOOTER TELA ABOUT E DRAWER
    BACKGROUND_FOOTER: "#F2DFA7", //COR DO RODAPÉ
    TEXT_FOOTER: "#2e2e2e", //USADA PARA O TEXTO DO RODAPÉ

    GRADIENT_MAIN: [
      "rgba(0,0,0,0.5)",
      "rgba(0,0,0,0.1)",
      "rgba(0,0,0,0.1)",
      "#402F20",
    ],

    //BOTÕES ARQUIVAR E PUBLICAR
    BACKGROUND_PUBLISH: "#F2DFA7", //COR DO RODAPÉ
    BACKGROUND_ARCHIVE: "#2e2e2e", //COR DO RODA
    TEXT_PUBLISH: "#2e2e2e", //USADA PARA O TEXTO DO RODAPÉ
    TEXT_ARCHIVE: "#FFFFFF", //USADA PARA O TEXTO DO RODAPÉ
  },

  FONTFAMILY: {
    BOLD: "text_Bold",
    MEDIUM: "text_Medium",
    REGULAR: "text_Regular",
    LIGHT: "text_Light",
    TITLE: "text_Title",
    SUBTITLE: "text_Subtitle",
    TEXTS: "text_Texts"
  },
  FONTSIZE: {
    EXTRABIG: RFValue(30, 980), //USADA 1X NA COURSES
    BIG: 26,
    STANDARD: 20,
    MEDIUM: 18,
    SMALL: 17,
    EXTRASMALL: 15,
  },
};
